/** Mapa central `API_ENDPOINTS`: rutas relativas del backend (clientes, vehículos, turnos, órdenes, catálogos, login) que consumen todos los módulos de esta capa. */
export const API_ENDPOINTS = {
  LOGIN: "User/login",
  POST_REFRESCAR_TOKEN: "User/RefrescarToken",
  POST_VEHICULO: "Vehiculos",
  GET_VEHICULOS: "Vehiculos",
  GET_VEHICULO_POR_PATENTE: "Vehiculos/patente",
  GET_VEHICULOS_BUSQUEDA: "Vehiculos/busqueda",
  GET_ITEMS_MENU: "Itemmenus",
  POST_ULTIMOMODULO: "Itemmenus/AccesoUltimoModulo",
  POST_MEDIDANEUMATICO: "Medidasneumaticos/CrearMedidasNeumatico",
  GET_MEDIDASNEUMATICOS: "Medidasneumaticos",
  GET_TIPOSVEHICULOS: "Vehiculos/Tipos",
  GET_COMBUSTIBLE_TIPO: "Vehiculos/tiposcombustible",
  GET_COMBUSTIBLE_CANTIDAD: "Vehiculos/combustiblecantidad",
  GET_COLORES: "Vehiculos/colores",
  GET_CLIENTES: "Clientes",
  POST_CLIENTES: "Clientes",
  PUT_CLIENTES: "Clientes",
  DELETE_CLIENTES: "Clientes",
  GET_CLIENTE_POR_NRO_DOCUMENTO: "Clientes/nrodocumento",
  GET_TIPOS_DOCUMENTO: "Clientes/tiposdocumento",
  GET_TIPOS_IVA: "Clientes/tiposiva",
  GET_TIPOS_FISCALES: "Clientes/tiposfiscales",
  GET_PROVINCIAS: "Clientes/provincias",
  GET_GRUPOS_EMPRESA: "Grupoempresas",
  GET_MARCAS: "Marcas",
  POST_MARCAS: "Marcas",
  POST_INSUMOS: "Insumos",
  GET_INSUMOS: "Insumos",
  GET_PRODUCTOS: "Productos",
  GET_PRODUCTOS_CON_STOCK_SUCURSAL: "Productos/constocksucursal",
  PUT_VEHICULO: "Vehiculos",
  DELETE_VEHICULO: "Vehiculos/patente",
  GET_TURNOS: "Turnos",
  GET_TURNO: "Turnos",
  GET_IMPRESION_TURNOS: "Turnos/impresion",
  POST_TURNO: "Turnos",
  PUT_TURNO: "Turnos",
  DELETE_TURNO: "Turnos",
  GET_AREAS_TRABAJO: "Turnos/areastrabajo",
  GET_OPERARIOS: "Personal/operarios",
  GET_JEFES_TALLER: "Personal/jefetaller",
  GET_HISTORIAL_VEHICULO: "Vehiculos/historial",
  // Se arma como `Vehiculos/{patente}/dueno` con body { codCliente }
  POST_CAMBIO_TITULAR: "Vehiculos",
  POST_ORDEN: "Ordenes",
  GET_ORDENES: "Ordenes",
  GET_ORDEN_POR_CODIGO: "Ordenes",
  GET_SERVICIOS_TAREAS: "ServiciosTareas/servicios",
  POST_SERVICIOS_TAREAS: "ServiciosTareas/servicios",
  GET_TRABAJOS_MECANICO: "Operarios",
  POST_ACCION_SERVICIO: "Ordenes",
  PUT_ORDEN: "Ordenes",
  DELETE_ORDEN: "Ordenes",
  GET_ACCIONES_PERMITIDAS: "Ordenes/accionespermitidas",
  GET_CONOS_EN_USO: "Ordenes/etiquetasenuso",
  // Se arma como `Ordenes/{codOrden}/impresion`
  GET_IMPRESION_ORDEN: "Ordenes",
} as const;
